// Generated by ReScript, PLEASE EDIT WITH CARE


function toUnsafeDomEventTarget(prim) {
  return prim;
}

export {
  toUnsafeDomEventTarget,
}
/* No side effect */
